export default __webpack_public_path__ + "static/media/rounded-arrow-up.f00abebf.svg";